import { render, staticRenderFns } from "./privati-personal-data.vue?vue&type=template&id=82f02d12&"
import script from "./privati-personal-data.vue?vue&type=script&lang=js&"
export * from "./privati-personal-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports